import React from "react";
import classNames from "classnames";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import InfoBlock from "../../../../../common/InfoBlock";
import GetUpdatedOnBy from "../GetUpdatedOnBy";
import { LogRenderContext } from "../LogRenderer";
import { formatDateTimeWithTz } from "../../../../../../utils/formatDateTimeWithTz";

const Resumed = ({ name, id, updatedAt, updatedBy }) => {
  const { log, userTimeZone } = React.useContext(LogRenderContext);
  const { statusChangeRequest } = log.changedFields;
  return (
    <div className={styles.tabContainer}>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <div className={styles.badgeContainer}>
          {!!name && <div className={styles.campaignName}>{name}</div>}
          <div className={classNames(styles.badge, styles.badgeSuccess)}>
            <div>Resumed</div>
          </div>
        </div>
        <GetUpdatedOnBy updatedAt={updatedAt} updatedBy={updatedBy} />
        <InfoBlock
          header="Resume Details"
          className={styles.changeTracking}
          config={[
            {
              title: "Resumed From",
              size: {
                sm: 6,
                xs: 6,
              },
              value: statusChangeRequest?.fromDate
                ? formatDateTimeWithTz(statusChangeRequest.fromDate, userTimeZone)
                : undefined,
            },
            {
              title: "Comments",
              size: {
                sm: 6,
                xs: 6,
              },
              value: statusChangeRequest?.comments,
            },
            {
              title: "Name & ID",
              size: {
                sm: 6,
                xs: 6,
              },
              value: `${name} (${id})`,
            },
          ]}
        />
      </div>
    </div>
  );
};
export default Resumed;
